/*
 * @Author: yuanjianlong
 * @Description: vuex
 * @Date: 2021-11-17 16:49:37
 * @LastEditTime: 2021-12-03 14:41:31
 * @FilePath: /teacher-h5/src/store/index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
const store = new Vuex.Store({
  modules,
  strict: debug
  // plugins: [
  //   createPersistedState()// 默认持久化所有state
  // ]
})
export default store
